import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './css/bootstrap.css';
import './css/style.css';
import './css/daterangepicker.css';
import './css/fontawesome-all.css';
import './css/global.css';
import './css/iconfont.css';
import './css/footer.css';
import './css/owl.css';
import './css/responsive.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
